// 运营商接入页面
export default [{
  path: '/operator/join',
  name: 'operatorJoin',
  hidden: true,
  component: () => import('@/module/memberCenter/page/operator/operator/join.vue')
}]



// WEBPACK FOOTER //
// ./src/module/memberCenter/router/operatorJoin.js